/**
 * How long execute() waits for a 3DS result before giving up. The promise is settled only by
 * a Cardinal callback, so with no bound a lost response leaves the caller awaiting forever
 * and the customer watching a spinner (see the stall notes in challengeHelpers).
 *
 * Ten minutes is deliberately generous: rejecting early on a customer who is still typing an
 * OTP loses exactly the money this bound exists to protect, and an ACS that has not answered
 * by then is not going to.
 */
export const THREE_DS_FLOW_TIMEOUT_MS = 600_000;

export enum TwoFAEvents {
  ERROR = 'error',
  CREATE_ORDER = 'create_order',
}

export enum CardinalEvents {
  SETUP_COMPLETE = 'payments.setupComplete',
  VALIDATED = 'payments.validated',
  ORDER_UPDATED = "order.updated",
  UI_CLOSE = "ui.close",
  UI_RENDER = "ui.render",
}

export enum CardinalValidatedActionCodes {
  SUCCESS = 'SUCCESS',
  NOACTION = 'NOACTION',
  FAILURE = 'FAILURE',
  ERROR = 'ERROR',
}

export enum CardinalPaymentBrand {
  CCA = 'cca', // Cardinal Consumer Authentication
}

export enum CybersourceResponseCodes {
  DAUTHENTICATE = '475', // The cardholder is enrolled in Payer Authentication. Please authenticate the cardholder before continuing with the transaction.
  SOK = '100', // Successful transaction
  // Other codes represents declined transactions. See details here: https://support.cybersource.com/s/article/What-does-this-response-code-mean
}

export enum CardinalWindowSizes {
  DESKTOP = '03',
  MOBILE = '02',
}
